import { DateFormatEnum as e, LanguageCodeEnum as t } from "@systemeio/types";
//#region src/date-time/date-time-format.ts
var n = /^\d{4}-\d{2}-\d{2}$/, r = /T\d{2}:\d{2}(:\d{2}(\.\d+)?)?(Z|[+-]\d{2}:?\d{2})$/, i = (e, n) => new Date(new Intl.DateTimeFormat(t.ENGLISH, {
	day: "2-digit",
	hour: "numeric",
	minute: "numeric",
	month: "2-digit",
	second: "numeric",
	timeZone: n,
	year: "numeric"
}).format(e)), a = (e, t) => e ? e instanceof Date ? i(e, t) : r.test(e) ? i(new Date(e), t) : n.test(e) ? /* @__PURE__ */ new Date(`${e}T00:00:00`) : new Date(e) : i(/* @__PURE__ */ new Date(), t), o = (e, t) => a(e, t), s = (e) => {
	let t = (e) => `${e}`.padStart(2, "0");
	return `${e.getFullYear()}-${t(e.getMonth() + 1)}-${t(e.getDate())}T${t(e.getHours())}:${t(e.getMinutes())}:${t(e.getSeconds())}`;
}, c = (t) => {
	switch (t) {
		case e.dateFirst: return "en-GB";
		case e.monthFirst: return "en-US";
		default: return;
	}
}, l = (e, t) => (typeof e == "string" ? new Date(e) : e).toLocaleString(c(t?.dateFormat), {
	day: "2-digit",
	month: "2-digit",
	timeZone: t?.timeZone,
	year: "numeric"
}), u = (e, t) => {
	if (!t && !e) return "";
	let n = new Intl.DateTimeFormat(e, {
		timeZone: t,
		timeZoneName: "shortOffset"
	}).formatToParts(/* @__PURE__ */ new Date()).find((e) => e.type === "timeZoneName");
	if (n) return n.value.replace("GMT", "UTC");
};
//#endregion
export { l as formatDate, o as getDate, u as getFormattedUtcOffset, i as getTimezoneDate, a as setDateWithTimezone, s as toISOStringWithoutTimezone };
